import { UPDATE_ACCOUNT } from "../constants/account-types"

export function updateAccount(accountObject){
    return {
      type: UPDATE_ACCOUNT,
      accountInfo: accountObject,
    };
}
